import styled from 'styled-components';
import {
  Button,
  Dialog,
  Fab,
  FormControl,
  FormControlLabel,
  IconButton,
} from '@mui/material';

export const InputContainerStyle = styled.div`
  .inputContainer {
    width: 100%;
  }
  .rightLabel {
    text-align: end;
    color: #016edc;
    font-weight: 600;
    padding-bottom: 5px;
    cursor: pointer;
    > div a {
      color: #016edc;
    }
  }
  .phone_container {
    display: flex;
    .react-tel-input {
      width: auto;
      .form-control {
        height: 38px;
        font-size: 14px;
        padding-left: 44px;
        border-radius: 4px;
        width: 94px;
        border: 1px solid #c4c4c4;
        &:hover {
          border-color: #333;
        }
      }
      .flag-dropdown {
        border: 0px;
        border-right: 0;
        background-color: transparent;
        &:hover {
          background-color: #0000000a;
        }
      }
      .selected-flag:hover {
        background-color: transparent;
      }
      .flag-dropdown.open .selected-flag {
        background-color: transparent;
      }
    }
    .phone_input {
      width: 100%;
      margin-left: 6px;
    }
  }
  .MuiInputAdornment-positionEnd {
    width: 45px;
    button {
      padding: 6px;
      margin-right: 7px;
    }
    svg {
      width: 20px;
      height: 20px;
      fill: ${({ theme }) => theme.svg1};
    }
  }
`;

// Button
export const ButtonStyle = styled(Button)`
  border-radius: 25px !important;
  text-transform: inherit !important;
  max-height: 36.5px;
  &.MuiButton-text,
  &.MuiButton-outlined {
    font-weight: 600;
  }
  svg {
    width: 18px;
    height: 18px;
  }
`;

// Auto Complete
export const AutoCompleteStyle = styled.div`
  width: 100%;
  .MuiAutocomplete-inputRoot {
    padding: 0px !important;
  }

  .rightLabel {
    text-align: end;
    color: #016edc;
    font-weight: 600;
    padding-bottom: 5px;
    cursor: pointer;
  }
  @media only screen and (max-width: 500px) {
    .MuiAutocomplete-option {
      font-size: 14px !important;
      min-height: 20px !important;
    }
  }
`;

// phone input
export const SelectInputStyle = styled.div`
  .selectContainer {
    width: 100%;
  }
  .multiselect-container {
    display: flex;
    gap: 2px;
  }
  .Mui-disabled {
    svg {
      background-color: transparent;
    }
  }
  .MuiPaper-root {
    max-height: 400px;
  }
`;

export const CheckboxStyle = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.fieldText1};
  }
  .MuiCheckbox-root {
    padding: 8px;
    &:not(.Mui-checked) {
      path {
        fill: ${({ theme }) => theme.fieldBorder1};
      }
      &:hover path {
        fill: ${({ theme }) => theme.fieldBorderHover1};
      }
    }
  }
`;

export const RadioButtonStyle = styled(FormControl)`
  .MuiFormControlLabel-label {
    font-size: 15px;
    font-weight: 500;
    color: ${({ theme }) => theme.fieldText1} !important;
    margin-left: 8px;
  }
  .MuiFormControlLabel-root {
    margin-left: 0;
    margin-right: 0;
  }
  .radio-helperText {
    font-size: 14px;
    color: ${({ theme }) => theme.tabText1} !important;
  }
  .MuiRadio-root {
    height: 25px;
    width: 25px;
    &:not(.Mui-checked) {
      path {
        color: #c4c4c4 !important;
      }
    }
  }
  .Mui-disabled {
    background-color: transparent;
  }
  .radio-label:hover {
    .css-vqmohf-MuiButtonBase-root-MuiRadio-root {
      background-color: ${({ theme }) => theme.hoverBg1};
    }
  }
`;

// Text Editor
export const TextEditorStyle = styled.div`
  position: relative;
  .textlength {
    float: right;
    font-size: 12px;
    color: ${({ theme }) => theme.gray[1]};
    margin-top: 2px;
  }
  .emoji-container {
    position: absolute;
    right: 13px;
    top: 9px;
  }
  .ql-tooltip {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
  .ql-blank::before {
    left: 12px;
    font-style: normal;
    font-size: 18px;
    color: ${({ theme }) => theme.gray[1]};
  }

  .ql-toolbar {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding: 5px;
    .ql-formats {
      margin-right: 10px;
      .ql-stroke {
        stroke: ${({ theme }) => theme.tabText1};
      }
    }
    .ql-formats .ql-fill,
    .ql-formats .ql-stroke.ql-fill {
      fill: ${({ theme }) => theme.tabText1};
    }
    .ql-emojiButton {
      svg {
        fill: ${({ theme }) => theme.tabText1};
        &:hover {
          fill: #1976d2;
        }
      }
    }
    .ql-formats:nth-child(4) {
      float: right;
      margin-right: 0;
      svg {
        width: 22px;
        height: 22px;
        position: relative;
        bottom: 1px;
      }
    }
  }
  .ql-container {
    height: 155px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    font-size: 15px;
    .ql-editor {
      padding: 8px 12px;
      ul {
        padding: 0;
      }
      p {
        font-size: 15px;
      }
    }
  }
  #emoji-palette {
    max-width: 300px;
    border-radius: 5px;
  }
  #tab-toolbar {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    ul {
      display: flex;
      justify-content: space-evenly;
    }
  }
  #tab-panel {
    padding: 8px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    max-height: 250px;
    .ap {
      margin: 5px;
    }
    .ap-speech {
      display: none;
    }
  }
  .editor-popup {
    position: absolute;
    background-color: ${({ theme }) => theme.Bg1};
    border: 1px solid ${({ theme }) => theme.fieldBorder1};
    border-radius: 4px;
    transform: translateY(5px);
    z-index: 1000;
    width: 220px;
    max-height: 200px;
    overflow-y: auto;
    font-size: 14px;
  }
`;

export const EditorPopupItem = styled.div`
  color: ${({ theme }) => theme.text1};
  background-color: ${({ theme, isfocus }) =>
    isfocus ? theme.hoverBg1 : theme.Bg1};
  padding: 8px 12px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    background-color: ${({ theme }) => theme.hoverBg1};
  }
`;

export const IconBtn = styled(IconButton)`
  &.MuiIconButton-sizeSmall {
    svg {
      width: 20px;
      height: 20px;
    }
  }
  &.MuiIconButton-colorError {
    path {
      fill: #d32f2f;
    }
  }
`;

export const ImageUploadStyle = styled.div`
  .uploadImgcontainer {
    border: 1px dashed ${({ theme }) => theme.fieldBorder1};
    // border-radius: 4px;
    border-radius: 10px;
    // height: 116px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .previewImg {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .img-actions {
        position: absolute;
        top: 4px;
        right: 4px;
        display: flex;
        > div,
        > button {
          border-radius: 50%;
          background-color: #f8f8f8;
          opacity: 0.7;
          margin-left: 4px;
        }
      }
      .img-delete path {
        fill: red;
      }
      img {
        width: 100%;
        height: 150px;
        object-fit: cover;
        border-radius: 10px;
      }
    }
    .close-icon-container {
      position: absolute;
      right: 5px;
      top: 5px;
    }
    .dropzone {
      svg {
        fill: #828282;
      }
    }
  }
  .upload-hover {
    border: 1px dashed ${({ theme }) => theme.fieldBorder1};
    border-radius: 4px;
    height: 116px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .isRoundProfile {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin: 0 auto;
    .img-actions {
      top: -20px !important;
      right: -50px !important;
    }
    img {
      border-radius: 50% !important;
    }
  }
  .upload-hover:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.lightGray};
  }
  .dropzone-block {
    .dropzoneContainer {
      color: ${({ theme }) => theme.fieldText1};
      border-radius: 4px;
      border: 1px dashed ${({ theme }) => theme.fieldBorder1};
      font-size: 14px;
      min-height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      background-color: ${({ theme, disabled }) =>
        disabled ? theme.fieldDisable1 : theme.modalBg1};
      cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
      &:hover {
        background-color: ${({ theme, disabled }) =>
          disabled ? theme.fieldDisable1 : theme.lightGray};
      }
      h3 {
        margin: 0;
      }
    }
  }
  .prev-parent {
    position: relative;
    width: 100%;
  }
`;

export const DatePickerStyle = styled.div`
  .datePickerContainer {
    display: grid;
    position: relative;
    input {
      height: 37px;
      font-size: 14px;
      border-radius: 4px;
      cursor: text;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
        'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
        'Helvetica Neue', sans-serif;
      border: 1px solid #b6b6b6;
      padding-inline-start: 8px;
      padding-inline-end: 8px;
      background-color: ${({ disabled }) => (disabled ? '#0000000a' : '#fff')};
      &:hover {
        border: 1px solid ${({ disabled }) => (disabled ? '#b6b6b6' : '#333')};
      }
    }
    input[type='date']::-webkit-calendar-picker-indicator {
      cursor: pointer;
    }
  }
`;

export const ModelStyle = styled(Dialog)`
  /* .selectContainer .ant-select .ant-select-selector {
    background-color: transparent !important;
  } */

  .title-mo {
    text-transform: uppercase;
  }

  .modelContainer {
    .modal-cancel {
      border: 1px solid #fabc05;
      background: white;
      margin: 0 10px;
    }
    .modal-footer {
      padding: 10px;
      border-top: 1px solid #d7d7d7;
    }
  }
  .Business-update-modal {
    background: red;

    .MuiDialog-container {
      .MuiDialog-paper {
        width: 600px !important;
      }
    }
  }
`;

export const CloseIconContainer = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.lightGray};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${({ theme }) => theme.lightGrayHover};
  }
  svg {
    padding: 3px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    path {
      fill: ${({ theme }) => theme.svg1};
    }
  }
`;

export const BrandIconSpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background-color: ${({ theme }) =>
    theme.mode === 'light' ? '#ffffff80' : '#00000080'};
  .loader-content {
    position: relative;
    width: 70px;
    height: 70px;
  }
  .loader {
    border-radius: 50%;
    border-top: 6px solid #ff6b6b;
    border-right: 6px solid #ffd93d;
    border-bottom: 6px solid #6bcb77;
    border-left: 6px solid #4d96ff;
    width: 60px;
    height: 60px;
    -webkit-animation: spin 1.5s linear infinite;
    animation: spin 1.5s linear infinite;
    z-index: 343434;
    position: absolute;
  }
  svg {
    width: 42px;
    height: 42px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const CarouselStyle = styled.div`
  .cmy-carousel-list {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 2px);
    height: 250px;
    border-radius: 2px;
    background-color: ${({ theme }) => theme.Bg1};
    img {
      max-width: calc(100% - 2px);
      max-height: 250px;
      border-radius: 2px;
    }
  }
  .carousel-action {
    z-index: 2;
    position: absolute;
    top: 5px;
    right: 10px;
    svg path {
      fill: red;
    }
  }
  .delete-icon {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
  .MuiIconButton-root:hover {
    background-color: #000 !important;
  }
`;

export const ImageEditor = styled.div`
  position: relative;
  .edit-action-container {
    position: absolute;
    top: 0px;
    display: flex;
    gap: 10px;
    z-index: 99;
  }
`;

export const StyledFab = styled(Fab)`
  position: fixed !important;
  bottom: 40px;
  right: 40px;
  width: 45px !important;
  height: 45px !important;
  z-index: 1000 !important;
  background-color: ${({ theme }) => theme.lightGray} !important;
  box-shadow: none !important;
  &:hover {
    background-color: ${({ theme }) => theme.lightGrayHover} !important;
  }
  svg {
    width: 20px;
    height: 20px;
    fill: ${({ theme }) => (theme.mode === 'light' ? '#333' : '#fff')};
  }
  @media only screen and (max-width: 599px) {
    display: none !important;
  }
`;

export const ImageCropWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .reactEasyCrop_Container {
    border-radius: 4px;
  }

  .image-crop-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .circle-uploader-container {
    position: relative;
  }

  .profile-icon-actions {
    z-index: 999;
    position: absolute;
    top: 10px;
    right: -70px;
    display: flex;
    gap: 8px;
  }

  .circle-uploader {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    border: 2px dashed ${({ theme }) => theme.fieldBorder1};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    svg {
      width: 24px;
      height: 24px;
      fill: ${({ theme }) => theme.tabText1};
    }
    &:hover {
      background: ${({ theme }) => theme.tabBg1};
    }
  }

  .circle-upload-block {
    text-align: center;
    > div {
      margin-top: 4px;
      color: ${({ theme }) => theme.tabText1};
    }
  }

  .cropper-container {
    position: relative;
    width: 100%;
  }

  .cropper-wrapper {
    width: 100%;
    height: 250px;
    position: relative;
  }

  .zoom-slider {
    width: 60%;
    margin: 16px auto 0;
    display: flex;
    align-items: center;
    gap: 18px;

    button {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      display: flex;
      align-items: center;

      svg {
        width: 20px;
        height: 20px;
        path {
          fill: ${({ theme }) => theme.svg1};
        }
      }

      &:hover svg {
        path {
          fill: #1976d2;
        }
      }
    }

    .MuiSlider-root {
      flex: 1;
      height: 4px;
    }

    .MuiSlider-thumb {
      width: 12px;
      height: 12px;
    }

    .MuiSlider-track {
      border: none;
    }

    .MuiSlider-rail {
      opacity: 0.3;
    }
  }

  .icon-actions {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    gap: 8px;
  }

  .icon-button {
    background: ${({ theme }) => theme.lightGray};
    border-radius: 50%;
    padding: 6px;
    width: 20px;
    height: 20px;
    box-shadow: ${({ theme }) => theme.boxShadow1};
    cursor: pointer;

    &:hover {
      background: ${({ theme }) => theme.lightGrayHover};
    }
  }

  .icon-upload {
    path {
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .icon-back {
    position: absolute;
    top: 10px;
    left: 10px;
    path {
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .icon-delete {
    path {
      fill: ${({ theme }) => theme.red1};
    }
  }
`;

export const PullToRefreshStyle = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  height: 50;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: none;
  transition: top 0.2s ease;
  padding-top: env(safe-area-inset-top);
  .refresh-icon {
    path {
      fill: ${({ theme }) => theme.svg1};
    }
  }
`;

export const ReportContent = styled.div`
  .report-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    text-align: center;
  }
  .report-reasons-list {
    max-height: 300px;
    overflow-y: auto;
  }
  .report-radio-button {
    .MuiFormControl-root {
      width: 100%;
    }
    .MuiFormControlLabel-root {
      width: 100%;
      padding: 10px;
    }
    .MuiFormControlLabel-label {
      font-size: 16px;
    }
  }
  .report-submit-button {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    button {
      width: 50%;
    }
  }
`;

export const TiltRootContainer = styled.div`
  display: inline-block;
  position: relative;
  perspective: 1200px;
  transform-style: preserve-3d;
  border-radius: 16px;
  cursor: grab;
  user-select: none;

  &:active {
    cursor: grabbing;
  }

  .tilt-inner {
    width: 100%;
    height: 100%;
    border-radius: 14px;
    overflow: hidden;
    transform-origin: center center;
    transition: transform 220ms cubic-bezier(0.2, 0.9, 0.25, 1),
      box-shadow 220ms ease;
    will-change: transform, box-shadow;
    background: linear-gradient(180deg, #fff 0%, #fbfdff 100%);
    box-shadow: 0 10px 30px rgba(10, 20, 40, 0.12);
    position: relative;
  }

  .tilt-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
    pointer-events: none;
    transform-origin: center center;
  }

  .tilt-glare {
    position: absolute;
    inset: 0;
    pointer-events: none;
    border-radius: inherit;
    mix-blend-mode: overlay;
    background: radial-gradient(
      600px 200px at 50% 50%,
      rgba(255, 255, 255, 0.18),
      rgba(255, 255, 255, 0.02) 40%,
      rgba(255, 255, 255, 0) 70%
    );
    opacity: 1;
    transition: background 120ms linear;
  }

  @media (prefers-reduced-motion: reduce) {
    .tilt-inner {
      transition: none !important;
    }

    .tilt-inner,
    .tilt-img,
    .tilt-glare {
      transform: none !important;
      box-shadow: 0 8px 18px rgba(10, 20, 40, 0.12) !important;
    }
  }
`;
